import { ITideMarkerData } from 'types/tides.js';
import { TideRow } from './tide-row.js';

export const TidesRows = ({
  tideData,
  filteredHeaders,
  tidesColumnCount,
}: {
  tideData: Array<ITideMarkerData>;
  filteredHeaders: Array<string>;
  tidesColumnCount: number;
}) => {
  // If the first piece of data doesn't match the header (index 1 since 0 is name) then it stars in the next column.
  const isTidesOffset = tideData[0].type.toUpperCase() !== filteredHeaders[0].toUpperCase();

  let rows: Array<ITideMarkerData | null> = isTidesOffset ? [null] : [];
  rows = rows.concat(tideData);

  if (rows.length < tidesColumnCount) {
    for (let i = rows.length; i < tidesColumnCount; i++) {
      rows.push(null);
    }
  }

  return (
    <>
      {rows.map((tide, index) => {
        return <TideRow tide={tide} head={filteredHeaders[index]} key={`tide-rows-${index}`} />;
      })}
    </>
  );
};
